import React,{ useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider } from 'antd';
import { PlusOutlined, ArrowRightOutlined  } from '@ant-design/icons';

import star from '../../image/star.svg'

import Star from '../Star/Star'

import './CardDom.less'

const CardDom = ({type, content, btnConfig}) =>{
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  if(type === 'text'){
    let textStyle = {
      topSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)'
    }
    return (
      <div style={width > 770? {}:{marginTop: 20}}>
        <div style={{fontSize: textStyle.topSize}}>{content.top}</div>
        <Divider style={{ borderColor: '#272724', margin:'15px 0' }} />
        <div style={{display:'flex'}}>
          <div>
            <div style={{fontSize: textStyle.titleSize}}>{content.title}</div>
            <div style={{fontSize: textStyle.descriptionSize, color:'rgba(0,0,0,0.5)', marginTop:'10px'}}>{content.description}</div>
          </div>
          <div>
            {btnConfig.icon === 'PlusOutlined'? <PlusOutlined style={width > 770? {fontSize: 24}:{fontSize: 20}}/>:''}
            {btnConfig.icon === 'ArrowRightOutlined'? 
              <ArrowRightOutlined style={width > 770? {fontSize: 24}:{fontSize: 20}} onClick={()=> {if(btnConfig.link) navigate(btnConfig.link)}}/>:''}
          </div>
        </div>
      </div>
    )
  }else if(type === 'img'){
    let textStyle = {
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
      itemSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'
    }
    return (
      <div onClick={()=> navigate(btnConfig.link)}>
        <Divider style={{ borderColor: '#272724', margin:'0 0 15px 0' }} />
        <div style={{fontSize: textStyle.titleSize, display: 'flex', justifyContent:'space-between'}}>
          {content.title}
          <ArrowRightOutlined style={{fontSize: 24}}/>
        </div>
        <div style={{width:'100%',height:'100%',display:'flex',flexDirection: 'column-reverse',marginTop: 15, position:'relative'}}>
          {content.img}
          <div style={{width:'100%',height:'100%',display:'flex',flexDirection: 'column-reverse',padding: 20, position: 'absolute',color:'#fff',background: 'rgba(0, 0, 0, 0.2)'}}>
            {content.list.map((e,i)=>{
              return (
                <div 
                  key={i} 
                  style={{
                    width:'100%',
                    textAlign: 'left',
                    display:'flex',
                    alignItem:'center',
                    padding: 10, 
                    fontSize: textStyle.itemSize, 
                    fontWeight: 600,
                    borderBottom: i===content.list-1? '0':'1px solid #fff',
                    
                  }}>
                  <img src={e.icon} alt="" style={{marginRight: 20}}/> {e.name}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }else if(type === 'img2'){
    let textStyle = {
      // titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    }
    return (
      <div style={{cursor: 'pointer'}}>
        <Divider style={{ borderColor: '#272724', margin:'0 0 15px 0' }} />
        
        <div 
          style={{width:'100%',height:'100%',display:'flex',flexDirection: 'column',marginTop: 15, position:'relative',textAlign:'left'}}
          onClick={()=> {
            console.log(btnConfig.link)
            if(btnConfig.linkType){
              window.open(btnConfig.link, '_blank');
            }else{
              navigate(btnConfig.link)
            }
          }}
        >
          {content.img}
          <div style={{width:'100%', padding: '15px 0 10px'}}>
            {content.taglist?.map((e,i)=>{
              return (<span key={e}>
                {e} 
                <span style={{margin:'0 10px'}}>·</span>
              </span>)
            })}
            {/* <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{content.time}</span> */}
          </div>
          <div style={{fontSize: textStyle.titleSize}}>{content.title}</div>
        </div>
      </div>
    )
  }else if(type === 'ImgTimeLine'){
    let textStyle = {
      titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
      subTitleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
      descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    }
    return <div style={{width:'100%',display:'flex',flexDirection: 'column', justifyContent: 'flex-end',margin: '0 0 20px', position:'relative',textAlign:'left',transition: '0.3s'}}>
      <img src={content.img} style={{width: '100%',borderRadius:5}}/>
      <Divider style={{ borderColor: '#272724', margin:'15px 0' }} />
      <div style={{fontSize: textStyle.titleSize}}>{content.title}</div>
    </div>
  }else if(type === 'goods'){
    let textStyle = {
      titleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)'
    }
    return <div style={{cursor: 'pointer'}} onClick={()=> navigate(btnConfig.link)}>
      <div className="card-goods-img-box">
        <div className="card-goods-img1">
          {/* bestseller: true, tag: true*/}
          {content.bestseller? <span className="card-Bestseller">Bestseller</span>:''}
          {content.tag? 
            <div className="tag-box">
              <div className="text1">#1</div>
              <div>
                <div className="text2">Doctor Recommended</div>
                <div className="text3">Urolithin A Brand</div>
              </div>
            </div>
            :
            ''
          }
          <img style={{width:'100%'}} src={content.img} alt=""/>
        </div>
        <img className="card-goods-img2" src={content.imgHover} alt=""/>
      </div>
      <div>
        <div style={{margin: '10px 0',display:'flex',justifyContent:'space-between', alignItem:'center'}}>
          <span style={{fontSize: textStyle.titleSize,fontWeight:700}}>{content.title}</span>
          {/* <span style={{display:'flex',justifyContent:'space-between', alignItem:'center',lineHeight:'22px'}}>
            {content.star} ({content.commentCount}) 
            <img style={{width:16}} src={star} alt=""/>
          </span> */}
        </div>
        <div style={{fontSize: textStyle.descriptionSize, color:'rgba(0, 0, 0, 0.54)'}}>{content.description}</div>
      </div>
    </div>
  }else if(type === 'bigGoods'){
    let textStyle = {
      titleSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
      descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'
    }

    if(width > 770){
      return (
        <div className="card-bigGoods-box">
          <div className="card-goods-img-box">
            {content.tag? 
              <div className="tag-box">
                <div className="text1">#1</div>
                <div>
                  <div className="text2">Doctor Recommended</div>
                  <div className="text3">Urolithin A Brand</div>
                </div>
              </div>
              :
              ''
            }
            <img style={{width:'100%'}} src={content.img} alt=""/>
          </div>
          <div className="bigGoods-detail-box">
            {content.bestseller? <div className="card-Bestseller">Bestseller</div>:''}
            <span style={{fontSize: textStyle.titleSize, fontWeight: 700, margin:'16px 0 24px'}}>{content.title}</span>
            {/* <div style={{display:'flex', alignItem:'center',lineHeight:'22px', marginBottom: 16}}>
              <Star score={content.star}/>
              {content.star} · {content.commentCount}reviews
            </div> */}
            <div className="line-clamp-3" style={{fontSize: textStyle.descriptionSize, color:'rgba(0, 0, 0, 0.54)'}}>{content.description}</div>
            {/* <div className="detail-btn">More details</div> */}
            <div className="buy-btn" style={{marginTop: 50}} onClick={()=> navigate(btnConfig.link)}>购 买</div>
            <div className="notes">
              国内免费送货 
              <span style={{margin: '0 5px'}}>·</span> 
              <span style={{borderBottom: '1px solid #272724', cursor: 'pointer'}}>国际航运</span>
            </div>
          </div>
        </div>
      )
    }else{
      return (
        <div className="card-bigGoods-box" style={{padding:'0 25px', display:'block'}}>
          <div className="card-goods-img-box" style={{width:'100%'}}>
            {content.tag? 
              <div className="tag-box">
                <div className="text1">#1</div>
                <div>
                  <div className="text2">Doctor Recommended</div>
                  <div className="text3">Urolithin A Brand</div>
                </div>
              </div>
              :
              ''
            }
            <img style={{width:'100%'}} src={content.img} alt=""/>
          </div>
          <div className="bigGoods-detail-box" style={{width:'100%'}}>
            {content.bestseller? <div className="card-Bestseller" style={{marginTop:'40px'}}>Bestseller</div>:''}
            <span style={{fontSize: textStyle.titleSize, fontWeight: 700, margin:'16px 0 24px'}}>{content.title}</span>
            {/* <div style={{display:'flex', alignItem:'center',lineHeight:'22px', marginBottom: 16}}>
              <Star score={content.star}/>
              {content.star} · {content.commentCount}reviews
            </div> */}
            <div className="line-clamp-3" style={{fontSize: textStyle.descriptionSize, color:'rgba(0, 0, 0, 0.54)'}}>{content.description}</div>
            {/* <div className="detail-btn">More details</div> */}
            <div className="buy-btn" style={{marginTop: 20}} onClick={()=> navigate(btnConfig.link)}>购 买</div>
            <div className="notes">
              国内免费送货 
              <span style={{margin: '0 5px'}}>·</span> 
              <span style={{borderBottom: '1px solid #272724', cursor: 'pointer'}}>国际航运</span>
            </div>
          </div>
        </div>
      )
    }

  }else if(type === 'icon'){
    return (
      <div>
        {content.top}
        {content.divider && <Divider style={{ borderColor: '#272724', margin:'15px 0 0' }} />}
        <div style={{display:'flex', margin:'15px 0 0'}}>
          <div>
            <div style={{fontSize: content.titleSize}}>{content.title}</div>
            <div style={{fontSize: content.subTitleSize, color:'rgba(0,0,0,0.54)'}}>{content.subTitle}</div>
            <div className="line-clamp-2" style={{fontSize: content.descriptionSize, color:'rgba(0,0,0,0.54)', marginTop:'10px'}}>{content.description}</div>
          </div>
          <div>
            {btnConfig && btnConfig.icon === 'PlusOutlined'? 
              <PlusOutlined style={width > 770? {fontSize: 24,height: 28}:{fontSize: 20,height: 28}}/>
              :
              ''
            }
          </div>
        </div>
      </div>
    )
  }else{
    return <></>
  }
}

export default CardDom